import App from '../app';
import currentSession from './currentSession';
import {Team} from '../model/Team';

export default function currentTeam(): Team | null {
  const {teamId} = currentSession();
  return App.useQuery(state => state.team.get(teamId.id));
}